import {Component, OnDestroy} from '@angular/core';
import {AlertController, NavController, NavParams, Platform, PopoverController} from 'ionic-angular';
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {AddFotoPopoverComponent} from "../../components/add-foto-popover/add-foto-popover";
import {Camera} from "@ionic-native/camera";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import {blobToDataURL} from "blob-util";
import {DeleteFotoPopoverComponent} from "../../components/delete-foto-popover/delete-foto-popover";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {Subscription} from "rxjs/Subscription";
import {ContactService} from "../../store/contact/contact.service";
import {ContactEntity} from "../../store/contact/contact.entity";
import {AuditService} from "../../store/audit/audit.service";
import {ProtocolService} from "../../store/protocol/protocol.service";

/**
 * Generated class for the KontakteDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@AutoUnsubscribe()
@Component({
  selector: 'page-kontakte-details',
  templateUrl: 'kontakte-details.html',
})
export class KontakteDetailsPage implements OnDestroy{

  public contact: ContactEntity = null;
  private contactOld: ContactEntity;
  private editMode: boolean = false;

  public logo: string = null;
  public unterschrift: string = null;
  private _customerSubscription: Subscription;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public dataProvider: DataProvider,
              private popoverCtrl: PopoverController,
              private camera: Camera,
              private loadingProvider: LoadingServiceProvider,
              private platform: Platform,
              private alertCtrl: AlertController,
              private auditService: AuditService,
              public contactService: ContactService,
              private protocolService: ProtocolService) {
    let _contact = this.navParams.get('contact');
    this.editMode = this.navParams.get('editMode') || false;

    if(_contact._id){
      this._customerSubscription = this.contactService.getById(_contact._id)
        .subscribe((contact) => {
          if(contact){
            this.contact = contact;

            if(this.contact._attachments){
              let  logoAttachmentName = null;
              for(let attachmentName in this.contact._attachments){
                if(attachmentName.indexOf('logo') !== -1){
                  logoAttachmentName = attachmentName;
                  break;
                }
              }
              if(logoAttachmentName){
                this.dataProvider.getAttachment(this.contact._id, logoAttachmentName)
                  .then((logo) => {
                    blobToDataURL(logo)
                      .then((base64) => {
                        this.logo = base64;
                      })
                  })
              }
            }
          }
        })
    }
    else {
      this.contact = _contact;
    }
  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad KontakteDetailsPage');
  }

  public save(close: boolean = true):Promise<any> {

    return new Promise((resolve, reject) => {
      if(JSON.stringify(this.contactOld) !== JSON.stringify(this.contact))
      {
        if(this.contact._id){
          //update

          //check if the document comes from the systemDB
          if(this.contact.system){
            this.contact = this.contactService.convertToUserDocument(this.contact);
          }
          this.contactService.set(this.contact, false);
        }
        else {
          this.contactService.add(this.contact, false);
        }
      }
      if(close){
        this.editMode = false;
        this.navCtrl.pop();
      }
    })
  }

  public edit():void {
    this.contactOld = JSON.parse(JSON.stringify(this.contact));
    this.contact = JSON.parse(JSON.stringify(this.contact));
    this.editMode = true;
  }

  public delete():void {

      let contactType = this.contact.type === 1 ? 'Kunde' : 'Auftragnehmer';
      let message = this.contact.type === 1 ? 'Möchten Sie den Kunden und alle dazugehörigen Prüfungen wirklich löschen?' : 'Möchten Sie den Auftragnehmer wirklich löschen?';

      let alert = this.alertCtrl.create({
        title: contactType + ' löschen?',
        message: message,
        buttons: [
          {
            text: 'Abbrechen',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          },
          {
            text: 'OK',
            handler: () => {
              this.contact.type === 1 ? this._deleteCustomer() : this._deleteContractor();
            }
          }
        ]
      });
      alert.present();
  }

  private _deleteContractor(): void {

    this.auditService.getAllByCustomerId(this.contact._id)
      .take(1)
      .subscribe((pruefungen) => {
        for(let pruefung of pruefungen){
          //protokolIds
          for(let protokollId of pruefung.protokolle){
            this.protocolService.deleteById(protokollId, false);
          }
          this.auditService.remove(pruefung, false);
        }
        this.contactService.remove(this.contact);
        this.editMode = false;
        this.navCtrl.pop();
      });
  }

  private _deleteCustomer(): void {
    this.contactService.remove(this.contact);
    this.editMode = false;
    this.navCtrl.pop();
  }

  public addPicture(pictureType: string):void {

    if(!this.contactService.hasUserEditPermission(this.contact)){
      return;
    }



    let _popover = this.popoverCtrl.create(AddFotoPopoverComponent);
    _popover.onDidDismiss((response) => {

      //if we have not a _id, then first we need to update(save) the document
      this.save(false)
        .then((savedContact) => {
          this.contact = savedContact;
          if(response){
            switch (response.type) {
              case 'camera':
                this._openCamera(pictureType);
                break;
              case 'album':
                this._openImagePicker(pictureType);
                break;
              case 'filePicker':
                this._processFile(pictureType, response.data);
                break;
            }
          }
        })
    });
    _popover.present({
      ev: event
    });
  }

  private _openCamera(pictureType: string): void {
    const options = {
      quality: 60,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum: true,
      correctOrientation: true,
      targetWidth: 1024,
      targetHeight: 1024
    };

    if(this.platform.is('cordova')){
      this.camera.getPicture(options).then((imageData) => {
        // let base64Image = 'data:image/jpeg;base64,' + imageData;

        this.dataProvider.saveAttatchment(this.contact._id, pictureType, imageData, 'image/jpeg')
          .then((success) => {
            console.log('successfully add picture with type: ' + pictureType);
            console.dir(this.contact);
            this.dataProvider.getAttachment(this.contact._id, pictureType)
              .then((logo) => {
                blobToDataURL(logo)
                  .then((base64) => {
                    this[pictureType] = base64;
                  })
                  .then(() => {
                    this.loadingProvider.dismiss();
                  })
              }, (error) => {
                this.loadingProvider.dismiss();
              });
          }, (error) => {
            this.loadingProvider.dismiss();
          });
      }, (err) => {
        // Handle error
        this.loadingProvider.dismiss();
      });
    }
    // else{
    //   let base64Image = this.globalProvider.testImage;
    //   this.loadingProvider.dismiss()
    // }

  }

  private _openImagePicker(pictureType: string):void {
    const options = {
      quality: 60,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
      targetWidth: 1024,
      targetHeight: 1024
    };

    if(this.platform.is('cordova')){
      this.camera.getPicture(options).then((imageData) => {
        // let base64Image = 'data:image/jpeg;base64,' + imageData;
        this.dataProvider.saveAttatchment(this.contact._id, pictureType, imageData, 'image/jpeg')
          .then((success) => {
            console.log('successfully add picture with type: ' + pictureType);
            console.dir(this.contact);
            this.dataProvider.getAttachment(this.contact._id, pictureType)
              .then((logo) => {
                blobToDataURL(logo)
                  .then((base64) => {
                    this[pictureType] = base64;
                  })
                  .then(() => {
                    this.loadingProvider.dismiss();
                  })
              }, (error) => {
                this.loadingProvider.dismiss();
              });
          }, (error) => {
            this.loadingProvider.dismiss();
          });

      }, (err) => {
        // Handle error
        this.loadingProvider.dismiss();
      });
    }
    // else{
    //   let base64Image = this.globalProvider.testImage2;
    //   this.loadingProvider.dismiss();
    //
    //   if(!this.contact["_attachments"]){
    //     this.contact["_attachments"] = [];
    //   }
    //
    //   this.contact._attachments[pictureType] = {"content_type": 'image/jpeg', "data": base64Image};
    //
    //   this.dataProvider.saveAttatchment(this.contact._id, pictureType, base64Image, 'image/jpeg')
    //     .then((success) => {
    //       console.log('successfully add picture with type: ' + pictureType);
    //       console.dir(this.contact);
    //       this.dataProvider.getAttachment(this.contact._id, pictureType)
    //         .then((logo) => {
    //           blobToDataURL(logo)
    //             .then((base64) => {
    //               this[pictureType] = base64;
    //             })
    //         })
    //     })
    // }
  }

  private _processFile(pictureType:string, file): void {
    let imageData = file.content.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
    this.loadingProvider.dismiss();

    // if(!this.contact["_attachments"]){
    //   this.contact["_attachments"] = [];
    // }

    // this.contact._attachments[pictureType] = {"content_type": 'image/jpeg', "data": content};

    this.dataProvider.saveAttatchment(this.contact._id, pictureType, imageData, 'image/jpeg')
      .then((success) => {
        console.log('successfully add picture with type: ' + pictureType);
        console.dir(this.contact);
        this.dataProvider.getAttachment(this.contact._id, pictureType)
          .then((logo) => {
            blobToDataURL(logo)
              .then((base64) => {
                this[pictureType] = base64;
              })
              .then(() => {
                this.loadingProvider.dismiss();
              })
          }, (error) => {
            this.loadingProvider.dismiss();
          });
      }, (error) => {
        this.loadingProvider.dismiss();
      });
  }


  public deletePicture(pictureType: string):void {

    if(!this.contactService.hasUserEditPermission(this.contact)){
      return;
    }

    let _popover = this.popoverCtrl.create(DeleteFotoPopoverComponent);
    _popover.onDidDismiss((_delete) => {
      if(_delete){
        this.dataProvider.removeAttachment(this.contact._id, pictureType)
          .then(()=> {
            this[pictureType] = null;
            this.loadingProvider.dismiss();
          })
      }
    });
    _popover.present({
      ev: event
    });
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }
}



// WEBPACK FOOTER //
// ./src/pages/kontakte-details/kontakte-details.ts